/**
 * Gadget Guy Media 2.0 — Motion Foundation
 *
 * Pair with /src/design/tokens.css for consistent duration + easing.
 * Do NOT introduce Framer Motion or similar heavy libraries here.
 * If a specific section truly needs orchestration, wrap this helper.
 */

export const MOTION = {
  duration: {
    ui: 220,
    cta: 320,
    section: 600,
    hero: 1400,
  },
  easing: {
    out: "cubic-bezier(0.16, 1, 0.3, 1)",
    inOut: "cubic-bezier(0.65, 0, 0.35, 1)",
  },
};

/** Convenience: build a CSS transition string honoring reduced-motion at CSS level. */
export const transition = (property = "all", speed = "ui") =>
  `${property} ${MOTION.duration[speed]}ms ${MOTION.easing.out}`;

/** Runtime check for `prefers-reduced-motion: reduce`. */
export const prefersReducedMotion = () => {
  if (typeof window === "undefined") return false;
  return window.matchMedia?.("(prefers-reduced-motion: reduce)").matches ?? false;
};

/** React hook — returns true if the user prefers reduced motion, live-updates on change. */
import { useEffect, useState } from "react";
export const useRespectsReducedMotion = () => {
  const [reduced, setReduced] = useState(prefersReducedMotion);
  useEffect(() => {
    if (typeof window === "undefined") return;
    const mql = window.matchMedia("(prefers-reduced-motion: reduce)");
    const on = () => setReduced(mql.matches);
    mql.addEventListener?.("change", on);
    return () => mql.removeEventListener?.("change", on);
  }, []);
  return reduced;
};
